import { apiFetch } from "./client";
import type { Page, User } from "./types";
import type { ListParams } from "./customers";

export interface UserPayload {
  email: string;
  full_name: string;
  password?: string;
  is_active?: boolean;
  preferred_locale?: string;
  timezone?: string;
  session_profile?: string;
  idle_timeout_minutes?: number | null;
  haulier_id?: number | null;
  site_id?: number | null;
  group_ids?: number[];
}

export async function listUsers(params: ListParams = {}): Promise<Page<User>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/users${query ? `?${query}` : ""}`);
}

export async function createUser(data: UserPayload): Promise<User> {
  return apiFetch("/users", { method: "POST", body: JSON.stringify(data) });
}

export async function getUser(id: number): Promise<User> {
  return apiFetch<User>(`/users/${id}`);
}

export async function updateUser(id: number, data: Partial<UserPayload>): Promise<User> {
  return apiFetch<User>(`/users/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteUser(id: number): Promise<unknown> {
  return apiFetch(`/users/${id}`, { method: "DELETE" });
}

export async function setUserGroups(id: number, group_ids: number[]): Promise<User> {
  return apiFetch<User>(`/users/${id}/groups`, {
    method: "PUT",
    body: JSON.stringify({ group_ids }),
  });
}

export async function setUserGrant(
  id: number,
  permission_id: number,
  granted: boolean,
): Promise<unknown> {
  return apiFetch(`/users/${id}/grants`, {
    method: "POST",
    body: JSON.stringify({ permission_id, granted }),
  });
}
